import { configureStore, createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { authApi } from './api/authApi';
import { informeApi } from './api/informeApi';
import { userApi } from './api/userApi';
import { archivoApi } from './api/archivoApi';
import cartReducer, { syncWithApi } from './features/cartSlice';
import themeReducer from './features/themeSlice';
import typesOfReportsReducer from './features/typesOfReportsSlice';
import userReducer from './features/userSlice';
import { precioApi } from './api/precioApi';
import { ConfiguracionApi } from './api/ConfiguracionApi';
import { empresaApi } from './api/empresaApi';
import { cartApi } from './api/cartApi'; // Added import for cartApi
import notificationReducer from './features/notificationSlice';

// Create listener middleware to sync cartApi state with cartSlice
const cartSyncListenerMiddleware = createListenerMiddleware();

// Listen for successful cart API query responses
cartSyncListenerMiddleware.startListening({
  matcher: isAnyOf(
    cartApi.endpoints.getCart.matchFulfilled,
  ),
  effect: (action, listenerApi) => {
    const cartData = action.payload.data;
    console.log('Cart data from API:', action);
    if (cartData) {
      // Extract informes from the response and sync with cartSlice
      const informes = cartData.map((item: any) => item as unknown as any); // Adjust type as needed
      listenerApi.dispatch(syncWithApi(informes));
    }
  }
});

export const store = configureStore({
  reducer: {
    [authApi.reducerPath]: authApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [informeApi.reducerPath]: informeApi.reducer,
    [precioApi.reducerPath]: precioApi.reducer,
    [archivoApi.reducerPath]: archivoApi.reducer,
    [ConfiguracionApi.reducerPath]: ConfiguracionApi.reducer,
    [empresaApi.reducerPath]: empresaApi.reducer,
    [cartApi.reducerPath]: cartApi.reducer, // Added cartApi reducer
    userState: userReducer,
    theme: themeReducer,
    cart: cartReducer,
    reports: typesOfReportsReducer,
    notification: notificationReducer,
  },
  devTools: process.env.NODE_ENV === 'development',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      authApi.middleware,
      userApi.middleware,
      informeApi.middleware,
      precioApi.middleware,
      ConfiguracionApi.middleware,
      archivoApi.middleware,
      empresaApi.middleware,
      cartApi.middleware, // Added cartApi middleware
    ]),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

